import { Box, SectionHelper, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { ExternalLinkSmall, StatusAlertSmall } from '@wix/wix-ui-icons-common';
import React, { useEffect } from 'react';
import { BiCtaNames, BiNotificationTypes } from '../bi/types';
import { ACCESSIBILITY_TIPS_ARTICLE_ID } from '../consts';
import { useBiLogger } from '../hooks/use-bi-logger';
import { useSessionInfoContext } from '../hooks/use-session-info-context';
import { getArticleLink } from '../utils/get-article-link';
export const SecondaryBranchWarning = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    locale
  } = useSessionInfoContext();
  useEffect(() => {
    biLogger.notificationView({
      notificationType: BiNotificationTypes.ErrorMessageSecondaryBranch
    });
  }, [biLogger]);
  return /*#__PURE__*/React.createElement(SectionHelper, {
    size: "small",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    padding: "0 SP1 0 3px"
  }, /*#__PURE__*/React.createElement(StatusAlertSmall, null)), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '207px'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      Link: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "small",
        skin: "dark",
        suffixIcon: /*#__PURE__*/React.createElement(ExternalLinkSmall, {
          "aria-label": t('accessibility-wizard.welcome-screen.secondary-language-warning.cta.aria-label')
        }),
        underline: "always",
        weight: "thin",
        ellipsis: true,
        onClick: () => {
          biLogger.notificationCtaClick({
            ctaName: BiCtaNames.A11Checklist,
            notificationType: BiNotificationTypes.ErrorMessageSecondaryBranch
          });
          window.open(getArticleLink(ACCESSIBILITY_TIPS_ARTICLE_ID, locale ?? ''), '_blank');
        }
      })
    },
    i18nKey: "accessibility-wizard.welcome-screen.secondary-branch-warning.description",
    t: t
  })))));
};
//# sourceMappingURL=secondary-branch-error.js.map